import { format, formatDistanceToNow } from 'date-fns'
import moment from 'moment-jalaali'

export function fDate(date) {
  return moment(date).format('jYYYY/jM/jD')
  // return format(new Date(date), 'dd MMMM yyyy')
}

export function fTextDate(date) {
  return moment(date).format('jD jMMMM jYYYY')
}

export function fDateTime(date) {
  return moment(date).format('HH:mm')
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p')
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  })
}
